export default __webpack_public_path__ + "assets/img/ic-zoom-in.709662e96907b88a2f81574482c3be0a.svg";